export default __webpack_public_path__ + "static/media/Unnati-Hospital.59401952.png";